import moment from 'moment-timezone'
import prpfile from '@/components/User/profile.vue'
import tenant from '@/components/User/tenant.vue'
export default {
  components: {
    tenant,
    'user-profile': prpfile
  },
  computed: {
    Horizon() {
      return Horizon
    },
    isTenant() {
      return this.$store.state.user.type === 'corp'
    }
  },

  methods: {
    showUserProfile(user) {
      this.$refs.userProfile.user = user
      this.$refs.userProfile.visible = true
    },
    /**
         * Format the given date with respect to timezone.
         */
    formatDate(unixTime) {
      return moment(unixTime * 1000).add(new Date().getTimezoneOffset() / 60)
    },

    /**
         * Format the given date with respect to timezone.
         */
    formatDateIso(date) {
      return moment(date).add(new Date().getTimezoneOffset() / 60)
    },

    /**
         * Extract the job base name.
         */
    jobBaseName(name) {
      if (!name.includes('\\')) return name

      var parts = name.split('\\')

      return parts[parts.length - 1]
    },

    /**
         * Autoload new entries in listing screens.
         */
    autoLoadNewEntries() {
      if (!this.autoLoadsNewEntries) {
        this.autoLoadsNewEntries = true
        localStorage.autoLoadsNewEntries = 1
      } else {
        this.autoLoadsNewEntries = false
        localStorage.autoLoadsNewEntries = 0
      }
    },

    /**
         * Convert to human readable timestamp.
         */
    readableTimestamp(timestamp) {
      return this.formatDate(timestamp).format('YYYY-MM-DD HH:mm:ss')
    },
    /**
         * UTC时间转 标准时间.
         */
    utcToTime(utcTime) {
      utcTime = (utcTime.substring(utcTime.length - 1) === 'z') ? utcTime.substring(0, utcTime.length - 1) : utcTime
      return moment(utcTime).format('YYYY-MM-DD HH:mm:ss')
    },
    // 将中国标准时间转换为年月日时分秒格式
    toggleTime(date) {
      return moment(moment(date).valueOf()).format('YYYY-MM-DD HH:mm:ss')
    },
    // 获取今日日期
    getTodayDate() {
      return moment().format('YYYY-MM-DD')
    },

    // 获取当前时间
    now() {
      return moment().format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
